import { useCallback, useMemo, useState } from 'react';
import { useQuery } from '@apollo/client';
import { GET_ORGANIZATION_ITEMS } from '../graphql';
import { prepareDynamicDataFromBackendFacets } from '../utils';
import useGetFacetsData from './useGetFacetsData';

const useOrganizationItems = ({
    variables,
    selectedCategoryIds,
    onDataFetched  // callback for parent to handle data
}) => {
    // states
    const [otherMatchBarOptions, setOtherMatchBarOptions] = useState({});
    const [matchBarDynamicFields, setMatchBarDynamicFields] = useState([]);

    const { categories } = useGetFacetsData();

    const handleFetchedOrgItems = useCallback((orgItemsData) => {
        const { facets = [] } = (orgItemsData?.searchOrganizationObjects) || {};
        const { fields, options } = prepareDynamicDataFromBackendFacets(
            facets,
            categories,
            selectedCategoryIds
        );

        fields.forEach(fieldData => {
            if ((fieldData.id === "categories") && (fields.length === 1)) {
                // show note in filter if only category filter is there
                fieldData.infoText = "Select a category to load more filters"
            }
        })
        
        setOtherMatchBarOptions(options);
        setMatchBarDynamicFields(fields);

        // Callback to parent
        onDataFetched && onDataFetched(orgItemsData);
    }, [categories, selectedCategoryIds, onDataFetched]);

    const { loading, data, fetchMore, refetch } = useQuery(
        GET_ORGANIZATION_ITEMS,
        {
            variables,
            onCompleted: handleFetchedOrgItems
        }
    );

    const showSearchTag = useMemo(() => matchBarDynamicFields.length > 1, [matchBarDynamicFields])
    const tagSearchIndex = useMemo(() => matchBarDynamicFields.findIndex(fieldData => fieldData.id === "categories") + 1, [matchBarDynamicFields])

    return { loading, data, fetchMore, refetch, otherMatchBarOptions, matchBarDynamicFields, showSearchTag, tagSearchIndex };
};

export default useOrganizationItems;